import NavbarComponent from "@/components/Navbar"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"
import GreekLine from "@/components/GreekLine"
import Input from "@/components/input/Input"
import { useForm } from "react-hook-form"
import SubscriptionAPI from "@/app/api/subscription/subscription"
import { useState } from "react"
import clsx from "clsx"
import { subscriptionSchema } from "@/app/utils/validation"
import { getError, handleError } from "@/app/utils/helpers"
import { useGlobalContext } from "@/global/GlobalContext"
import ProcessModal from "@/components/ProcessModal"
import SEO from "@/components/SEO"
const subscriptionAPI = new SubscriptionAPI()

const ComingSoon = () => {
  const { notifyError } = useGlobalContext()
  const { register, handleSubmit, reset } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [modalContent, setModalContent] = useState(null)
  const defaultErr = {
    full_name: "",
    email: ""
  }
  const [errors, setErrors] = useState(defaultErr)

  const handleInsert = async (formData) => {
    setIsLoading(true)
    const err = await insertSubscription(formData)
    if (err) {
      if (typeof err.error[0] == "string") {
        notifyError(err.error[0])
      } else {
        const newErrs = handleError(err)
        setErrors({ ...newErrs })
      }
    }
    setIsLoading(false)
  }

  // API request
  const insertSubscription = async (formData) => {
    try {
      const insertedData = subscriptionSchema.safeParse({
        full_name: formData.full_name,
        email: formData.email
      })

      if (!insertedData.success) return { error: insertedData.error.issues }

      const { data } = await subscriptionAPI.insertSubscription(insertedData.data)
      if (data.code == 200) {
        setModalContent({ msg: data.message, isOpen: true })
        reset()
        setErrors(defaultErr)
      }
    } catch (err) {
      return getError(err)
    }
  }

  return (
    <>
      <SEO />
      <ProcessModal pModalContent={modalContent} />
      <NavbarComponent bgColor="bg-white" />
      <section className="bg-[url('/src/assets/imgs/di-sana/slide-07.jpg')] h-[50vh] w-full bg-cover relative">
        <GreekLine custCls="bottom-0 absolute w-full" />
      </section>
      <div className="px-5 sm:px-10 py-6 sm:py-8">
        <h1 className="font-sloopScriptPro text-6xl sm:text-8xl text-[#95702e] font-bold mb-3">Coming Soon</h1>
        <p className="text-charcoal-black text-base sm:text-2xl font-light font-agcasmlt sm:w-1/2 lg:w-[35%] inline-block mb-6">We're excited to share what we've been working on. Sign up to our newsletter to be among the first to know when our page launches.</p>
        <form onSubmit={handleSubmit(handleInsert)} className="flex items-center gap-5 sm:gap-9 w-full sm:w-[90%] lg:w-4/5 mb-5">
          <div className="flex gap-3 sm:gap-5 w-[70%] lg:w-[55%]">
            <div className="w-1/2">
              {/*  */}
              <Input type="text" comingSoonForm placeholder="Full Name" name="fullName" id="fullName" custCls={errors.full_name ? "border-red-600" : ""} errMsg={errors.full_name} ref={{ ...register("full_name") }} />
            </div>
            <div className="w-1/2">
              <Input type="text" comingSoonForm placeholder="Email Address" name="email" id="email" custCls={errors.email ? "border-red-600" : ""} errMsg={errors.email} ref={{ ...register("email") }} />
            </div>
          </div>
          <button type="submit" disabled={isLoading} className="self-start w-[30%] sm:w-[25%] p-1 border border-[#95702e]">
            <span className={clsx("bg-[#95702e] pb-1 pt-2 font-agcasmlt font-light text-sm sm:text-xl text-white block text-center", { "bg-[rgba(149,112,46,0.5)]": isLoading })}>
              Subscribe
            </span>
          </button>
        </form>
        <div className="ml-3">
          <span className="text-[10px] sm:text-[12px] text-[#cccccb]">Follow us on Instagram</span>
          <a href="https://www.instagram.com/disinidisana.bras" target="_blank" className="flex font-headlines text-xs sm:text-base leading-4 md:leading-5 2xl:leading-6 rounded text-[#95702e] items-center">
            <FontAwesomeIcon icon={faInstagram} className="mr-1" />
            @disinidisana.bras
          </a>
        </div>
      </div>
    </>
  )
}

export default ComingSoon
